import calendarSVG from '../../assets/icons/calendar.svg';
import { CoreIcon } from '../core-icon';

import type { IconProps } from '../core-icon';

export const CalendarIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={calendarSVG} {...props} />;
};
